import axios from 'axios';
import api from '@src/api';
import store from '@state/store';

export const state = initialState();

function initialState() {
  return {
    defaultOrganizationInfo: {
      name: 'SmartFitness',
      logo:
        'https://org-5f10adb325bfc2a6e1f9a1cf.s3.amazonaws.com/logo-light.png',
      support_email: 'team@smartfitness.com',
      pricing_url: 'https://smartfitness.com/pricing.html',
      primary_color: 'rgb(48, 112, 223)',
    },
    organizationInfo: null,
  };
}

export const getters = {
  organizationTitle(state) {
    console.log(store.state.auth);
    return state.organizationInfo?.name
      ? state.organizationInfo?.name
      : state.defaultOrganizationInfo.name;
  },
  organizationSupportEmail(state) {
    return state.organizationInfo?.support_email
      ? state.organizationInfo?.support_email
      : state.defaultOrganizationInfo.support_email;
  },
  organizationColor(state) {
    return state.organizationInfo?.primary_color
      ? state.organizationInfo?.primary_color
      : state.defaultOrganizationInfo.primary_color;
  },
  organizationLogo(state) {
    return state.organizationInfo?.mediaAssets &&
      state.organizationInfo?.mediaAssets['logo-light-png'] &&
      state.organizationInfo?.mediaAssets['logo-light-png']?.url
      ? state.organizationInfo.mediaAssets['logo-light-png'].url
      : state.defaultOrganizationInfo.logo;
  },
  organizationPricingURL(state) {
    return state.organizationInfo?.pricing_url
      ? state.organizationInfo?.pricing_url
      : state.defaultOrganizationInfo.pricing_url;
  },
};

export const mutations = {
  SET_ORG(state, value) {
    state.organizationInfo = value;
  },
};

export const actions = {
  getOrg({ commit }, orgID) {
    const url = api.URL_GET_ORG.replace(':orgID', orgID);
    // Minimum data check for obj
    if (orgID !== undefined) {
      return axios
        .get(url)
        .then((res) => {
          if (res.data.success) {
            console.log(res.data.org);
            commit('SET_ORG', res.data.org);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'orgID must contain the following properties to be a valid replacement [ orgID ]',
        orgID
      );
    }
  },
};
